import type { RouteObject } from 'react-router'

import { socialTopicsRoutes } from 'features/coverage/features/social-topics/routes'
import { COVERAGE_URL } from 'features/coverage/paths'
import { lazyComponent } from 'routes/lazy-route'

export const coverageRoutes: RouteObject[] = [
  {
    path: COVERAGE_URL,
    children: [
      {
        index: true,
        lazy: lazyComponent(
          () => import('features/coverage/Container'),
          'CoverageContainer',
        ),
        handle: { featureKey: COVERAGE_URL },
      },
      ...socialTopicsRoutes,
    ],
  },
]
